const moneyToCurrencyBr = (value) => {
  if (value !== null && value !== '') {
    const money = parseFloat(value)
    return money.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
  }
  return value
}

const moneyToCurrencyBrNoSymbol = (value, fraction = 2) => {
  if (value !== null && value !== '') {
    const money = parseFloat(value)
    return money
      .toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: fraction,
        maximumFractionDigits: fraction,
      })
      .replace('R$', '')
      .trim()
  }
  return value
}

export { moneyToCurrencyBr, moneyToCurrencyBrNoSymbol }
